import React, { useEffect, useState } from "react";
import {RiCloseCircleLine} from 'react-icons/ri'
import { useDispatch, useSelector } from "react-redux";
import { getCourseLecturesAction } from "../../redux/actions/courseAction";
import { MdDeleteForever } from "react-icons/md";
import { addLecturesAction, deleteLecturesAction } from "../../redux/actions/adminAction";
import { toast } from "react-hot-toast";
const LecturesModal = (props) => {
  // console.log(props.id);
  // console.log(props.coursename)

  
  const {lectures, loading} = useSelector(state => state.courses)
  const {loading:AdminLoading, error:AdminError} = useSelector(state => state.admin)



  const [image, setImage] = useState()

  const [lecturename, setLecturename] = useState("");
  const [lecturedescription, setLecturedescription] = useState("");

  const dispatch = useDispatch()
  useEffect(()=> {

    if (AdminError) {
      toast.error(AdminError);
      dispatch({
        type: "clearError",
      });
    }

    

    getCourseLecturesAction(props.id)

  }, [dispatch,AdminError, lectures, props.id])


  const changeVideoHandler = (e) => {
    // console.log(e.target.files[0])
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file)

    reader.onloadend = () => {
    //   setImagePreview(reader.result)
      setImage(file)
    //   console.log(reader.result)
    //   console.log(file)
    }
    
  }

  
  const addLecturesHandler= async(e) => {
    e.preventDefault()
    const myForm = new FormData();

    myForm.append('title', lecturename);
    myForm.append('description', lecturedescription);
    myForm.append('_id', props.id);
    myForm.append('file', image);
    await dispatch(addLecturesAction(myForm))
    dispatch(getCourseLecturesAction(props.id))


    // console.log(myForm)
  }


  const onDeleteHandler = async(lecture_id) => {
    // console.log(props.id, lecture_id)

    await dispatch(deleteLecturesAction(props.id, lecture_id))
    dispatch(getCourseLecturesAction(props.id))


    
  }


  

  return (
    <>
      <div className="px-10 py-10">
        <div className=" flex justify-between">
          <h1 className="uppercase text-blue-700 font-semibold text-2xl">{props.coursename}</h1>
          <button
            className=" text-red-700 text-3xl px-2 py-2"
            onClick={() => {
              props.setShowLectures(false);
            }}
          >
            < RiCloseCircleLine/>
          </button>
        </div>

        <div className="grid grid-cols-2">
          {/* grid 1  */}
          <div>
            <h1 className="text-2xl my-4 ">Lectures</h1>

            {!loading? lectures?.map((lecture, index) => (
              <div className="flex my-8" key={index}> <span className="mx-4">#{index + 1}</span> <span className="mx-4" >{lecture?.title}</span> <button onClick={() => {onDeleteHandler(lecture._id)}} className="text-red-600 text-xl" ><MdDeleteForever /></button></div>
            )) : <h1>Loading Lectures...</h1>}
          </div>

          {/* grid 2  */}
          <div>
            <form onSubmit={ (e)=> {addLecturesHandler(e)}} action="">
              <input
                className="my-3 w-full py-1 px-6 text-white bg-brand_jaguar border-b-2 outline-0 	focus:border-brand_yellow	"
                type="text"
                value={lecturename}
                placeholder="Lecture Name"
                onChange={(e) => {
                  setLecturename(e.target.value);
                }}
              />
              <input
                className="my-3 w-full py-1 px-6 text-white bg-brand_jaguar border-b-2 outline-0 	focus:border-brand_yellow	"
                type="text"
                value={lecturedescription}
                placeholder="Lecture Description"
                onChange={(e) => {
                    setLecturedescription(e.target.value);
                }}
              />


              <div>
                <label htmlFor="video">Upload File</label>
                <input
                  onChange={(e) => {
                    changeVideoHandler(e);
                  }}
                  accept="video/*"
                  className="w-full my-2  cursor-pointer"
                  id="profile"
                  type="file"
                />
              </div>
              <button disabled={AdminLoading}  className={` ${AdminLoading ? 'bg-yellow-100 text-gray-600' : 'bg-brand_yellow text-black  transition hover:-translate-y-1'} my-4 ease-linearpx-6 py-1 px-2 font-outfit font-semibold`}>
                Add Lectures
              </button>

            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default LecturesModal;
